import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-explorer-icon',
  templateUrl: 'explorer-icon.component.html'
})
export class ExplorerIconComponent {
  constructor() {}
}
